import { useEffect, useState } from 'react'
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Textarea
} from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { primary } from 'theme/globalStyles'

interface IFeedbackDetailProps {
  isOpen: boolean
  onClose: () => void
  handleSubmitFeedback: (text: string) => void
}

const FeedbackDetail = (props: IFeedbackDetailProps) => {
  const { isOpen, onClose, handleSubmitFeedback } = props
  const { organizationStore } = useStores()
  const { organization } = organizationStore
  const currentTheme = organization?.theme ?? {}
  const methods = useForm()
  const { getValues, handleSubmit, register, reset } = methods
  const [isLoading, setIsLoading] = useState(false)

  async function onSubmit(): Promise<void> {
    try {
      setIsLoading(true)
      const text: string = getValues('text')
      if (text) {
        await handleSubmitFeedback(text)
        onClose()
      }
      setIsLoading(false)
      toast.success('Submitted successfully')
    } catch (error: any) {
      setIsLoading(false)
      toast.error('Submitted failed')
    }
  }

  useEffect(() => {
    if (isOpen) {
      reset()
    }
  }, [isOpen])

  return (
    <>
      <Modal size="xl" isOpen={isOpen} onClose={onClose}>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader color="gray.800" fontSize="18px" fontWeight={500} lineHeight={7}>
                Feedback detail
              </ModalHeader>
              <ModalCloseButton background="white" border="none" boxShadow="none !important" />
              <ModalBody borderY="1px solid #E2E8F0" padding={6}>
                <FormControl>
                  <FormLabel marginBottom={2} color="gray.700">
                    What could help your search experience be better?
                  </FormLabel>
                  <Textarea
                    {...register('text')}
                    isRequired
                    placeholder="Ex: I’m getting improper search results for “machine”..."
                  />
                </FormControl>
              </ModalBody>
              <ModalFooter>
                <Button
                  type="submit"
                  border="0"
                  color="white"
                  fontSize="16px"
                  fontWeight={500}
                  lineHeight={6}
                  isLoading={isLoading}
                  background={currentTheme?.primaryColor ?? primary}
                  _hover={{ opacity: 0.8 }}
                >
                  Submit
                </Button>
              </ModalFooter>
            </ModalContent>
          </form>
        </FormProvider>
      </Modal>
    </>
  )
}

export default observer(FeedbackDetail)
